import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { IAppState } from '../store';
import { getUserProfile, IUserProfileData, IWhitelistedProduct } from '../actions/userAction';
import { getBorrowerProfile, IBorrowerProfileData } from '../actions/borrowerProfileAction';
import { rootPath } from '../constants/routes';
import { isRoleBorrowerAgent } from '../constants/roles';
import { getCurrentProductId } from '../utils/globalUtil';

interface ReduxStateProps {
    userId?: string;
    roles?: string[];
    name?: string;
    email?: string;
    data?: IUserProfileData | null;
    whitelistedProducts: IWhitelistedProduct[];
    borrowerProfile: IBorrowerProfileData | undefined;
}

const useUserProfile = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    roles, userId, name, email, data, whitelistedProducts, borrowerProfile,
  } = useSelector<IAppState, ReduxStateProps>((state) => {
    const currentProductId = getCurrentProductId();
    let availableRoles: string[] | undefined;

    if (currentProductId) {
      const availableProducts = state.userState.userProfileStateData?.whitelistedProducts;
      const whitelistedProduct = availableProducts?.find(
        (availableWhitelistedProduct) => availableWhitelistedProduct.productId === currentProductId,
      );

      availableRoles = whitelistedProduct?.roles;
    }

    return {
      userId: state.userState.userProfileStateData?.userId,
      roles: availableRoles,
      name: state.userState.userProfileStateData?.name,
      email: state.userState.userProfileStateData?.email,
      data: state.userState.userProfileStateData,
      whitelistedProducts: state.userState.userProfileStateData?.whitelistedProducts || [],
      borrowerProfile: state.borrowerProfileState.borrowerProfileStateData,
    };
  });

  useEffect(() => {
    if (roles === undefined) {
      dispatch(getUserProfile());
    }

    if (location.pathname !== rootPath) {
      if (borrowerProfile === undefined
        && roles !== undefined
        && isRoleBorrowerAgent(roles)
      ) {
        dispatch(getBorrowerProfile());
      }
    }
  }, []);

  return {
    roles, userId, name, email, data, whitelistedProducts,
  };
};

export default useUserProfile;
